import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import BulkProposals from "@/pages/BulkProposals";
export const Route = createFileRoute("/bulk")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><BulkProposals /></ProtectedRoute>) });
